import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DripSequenceGoalSet as DripSequenceGoalSetMutation,
    DripSequenceGoalSetVariables as DripSequenceGoalSetVariables,
    DripSequenceGoalSetInput,
} from 'nutshell-graphql-types';

import DRIP_SEQUENCE_GOAL_SET from '../mutations/drip-sequence-goal-set.graphql';

export const useDripSequenceGoalSet = (): {
    dripSequenceGoalSet: (arg1: DripSequenceGoalSetInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [dripSequenceGoalSet, {loading, error}] = useMutation<
        DripSequenceGoalSetMutation,
        DripSequenceGoalSetVariables
    >(DRIP_SEQUENCE_GOAL_SET);

    return {
        dripSequenceGoalSet: (input: DripSequenceGoalSetInput) =>
            dripSequenceGoalSet({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
